import isInteger from 'lodash-es/isInteger';

export const intToPageSizeOption = (int: number) => {
  if (isInteger(int)) {
    return {
      value: int.toString(),
      label: `${int} rows`,
    };
  } else {
    throw new Error(`Number passed to intToPageSizeOption must be an integer but ${int} was passed instead.`);
  }
};
